import {Component, inject, OnInit} from '@angular/core';
import {EmailPlayersButtonComponent} from "../../../components/email-players-button/email-players-button.component";
import {GameService} from "../../../services/game.service";
import {ContainerComponent} from "@coreui/angular";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {RouterLink} from "@angular/router";
import {MatButton} from "@angular/material/button";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {BroadcastNotificationsTableComponent} from "../../../components/broadcast-notifications-table/broadcast-notifications-table.component";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {BroadcastNotificationService} from "../../../services/broadcast-notification.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IBroadcastNotification} from "../../../interfaces/notifications/IBroadcastNotification";

@Component({
  selector: 'app-game-admin-manage-notifications',
  standalone: true,
  imports: [
    EmailPlayersButtonComponent,
    ContainerComponent,
    MatProgressSpinner,
    RouterLink,
    MatButton,
    HasPermissionDirective,
    BroadcastNotificationsTableComponent
  ],
  templateUrl: './game-admin-manage-notifications.component.html',
  styleUrl: './game-admin-manage-notifications.component.css'
})
export class GameAdminManageNotificationsComponent implements OnInit {
  private gameService: GameService = inject(GameService);
  private broadcastNotificationService: BroadcastNotificationService = inject(BroadcastNotificationService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  public broadcastNotifications: IBroadcastNotification[] = [];
  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;
  public permissionTypes = PermissionTypes;

  chosenGame: IGameQueryResult | null = null;

  ngOnInit() {
    this.chosenGame = this.gameService.activeGame();
    if (this.chosenGame?.Id) {
      this.loadNotificationsForGame(this.chosenGame.Id);
    }
  }

  private loadNotificationsForGame(gameId: string) {
    this.uiState = UIStateEnum.ShowLoading;
    this.broadcastNotificationService.getBroadcastNotificationsByGameId(gameId).subscribe({
      next: (notifications) => {
        this.broadcastNotifications = notifications;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        // Clear first: displayPageLevelErrorMessage rethrows, so don't leave stale rows rendered.
        this.broadcastNotifications = [];
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
